export var MessageEvent;

(function (MessageEvent) {
  MessageEvent["updateChatRoomID"] = "updateChatRoomID";
  MessageEvent["showContent"] = "showContent";
  MessageEvent["showPreview"] = "showPreview";
  MessageEvent["shareMessage"] = "shareMessage";
  MessageEvent["toggleChatroomDetail"] = "toggleChatroomDetail";
  MessageEvent["showAnnouncement"] = "showAnnouncement";
})(MessageEvent || (MessageEvent = {}));

export var MediaType;

(function (MediaType) {
  MediaType["image"] = "image";
  MediaType["video"] = "video";
  MediaType["quicktime"] = "video/quicktime";
})(MediaType || (MediaType = {}));